import cashPrize from './cashPrize'
import awardWin from './awardWin'
import coupon from './coupon'
import prize from './prize'

export default {
  ...prize,
  ...coupon,
  ...awardWin,
  ...cashPrize
}
